import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationDeleteSsoMembershipArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useDeleteSsoMembership = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationDeleteSsoMembershipArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()

  return useMutation<Action, ClientError, MutationDeleteSsoMembershipArgs>(
    input => client.auth.deleteSsoMembership(input),

    useMutationOptions,
  )
}
